import SecaoGramado from './SecaoGramado';

export { SecaoGramado };

export default SecaoGramado;
